<template>
  <el-dialog title="Adicionar Imagens" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" :modal-append-to-body="false" width="25%">
    <el-form size="small" label-position="top" hide-required-asterisk	:show-message="false">
      <el-form-item>
        <el-upload ref="upload" name="arquivo" :action="''" :auto-upload="false" class="file-upload-box" multiple accept="image/png,image/jpeg">
          <el-button type="primary" slot="trigger" style="width: 100%" icon="el-icon-search" round>Selecionar Arquivo</el-button>
          <div slot="tip">Arquivos jpg/png com tamanho de até 2MB</div>
        </el-upload>
      </el-form-item>
    </el-form>

    <span slot="footer">
      <el-button type="success" size="small" @click="uploadHandler()" style="margin-left: 10px;" round class="btn-box-shadow">Upload</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  props: {
    visibility: Boolean,
    tipo: String
  },
  data() {
    return {
      indiceUpload: 0,
      quantidadeArquivos: 0,
      quantidadeSucesso: 0,
      quantidadeFalha: 0
    }
  },
  computed: {
    ...mapState('vendasImoveisStore', {
      imovel(state) { return state.imovelSelecionado; }
    })
  },
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("vendasImoveisStore", ["uploadImagemImovel"]),
    uploadHandler() {
      if(this.$refs.upload.uploadFiles.length >= 1) {
        this.uploadArquivos();
      } else {
        this.$message.error("Selecione ao menos uma imagem");
      }
    },
    uploadArquivos() {
      this.quantidadeArquivos = this.$refs.upload.uploadFiles.length;
      this.indiceUpload = 0;
      
      this.showLoading();
      this.uploadImovel(this.$refs.upload.uploadFiles[0]);
    },
    uploadImovel(arquivo) {
      if(this.indiceUpload >= this.quantidadeArquivos) {
        this.fechar();
        return;
      }

      let payload = new FormData();

      payload.append("arquivo", arquivo.raw);
      payload.append("path", arquivo.name);
      payload.append("idImovel", this.imovel.id);

      this.uploadImagemImovel(payload)
      .then(resultado => {
        switch (resultado.status) {
          case "SUCESSO":
            this.$message.success("Upload " + (this.indiceUpload + 1) + " de " + this.quantidadeArquivos + " concluído com sucesso");
            this.quantidadeSucesso += 1;
            break;
          case "FALHA":
          case "ERRO":
            this.$message.error("Upload " + (this.indiceUpload + 1) + " de " + this.quantidadeArquivos + " falhou");
            this.quantidadeFalha += 1;
            break;
        }
        
        this.uploadImovel(this.$refs.upload.uploadFiles[++this.indiceUpload]);
      }).catch(() => {
        this.quantidadeFalha += 1;

        this.$message.error("Upload " + (this.indiceUpload + 1) + " de " + this.quantidadeArquivos + " falhou");
        this.uploadImovel(this.$refs.upload.uploadFiles[++this.indiceUpload]);
      });
    },
    
    reset() {
      if(this.$refs.upload) { this.$refs.upload.clearFiles(); }
      this.quantidadeArquivos = 0;
      this.quantidadeSucesso = 0;
      this.quantidadeFalha = 0;
    },
    fechar() {
      this.exibirMensagem();
      if(this.quantidadeArquivos == this.quantidadeSucesso + this.quantidadeFalha) {
        this.reset();
        this.$emit("close");
        this.hideLoading();
      }
    },
    exibirMensagem() {
      if(this.quantidadeArquivos == this.quantidadeSucesso) {
        this.$message.success((this.quantidadeSucesso == 1 ? "Imagem gravada com sucesso" : this.quantidadeSucesso + " imagens gravadas com sucesso"));
        return;
      } 
      
      if(this.quantidadeArquivos == this.quantidadesucesso + this.quantidadeFalha) {
        let texto = (this.quantidadeSucesso == 1 ? "Imagem gravada com sucesso" : this.quantidadeSucesso + " imagens gravadas com sucesso");
        texto += ". " + (this.quantidadeFalha == 1 ? "Ocorreu erro em 1 imagem" : "Ocorreram erros em " + this.quantidadeFalha + " imagens");
        this.$message.warning(texto);
        return;
      }
    }
  }
};
</script>

<style>
.file-upload-box .el-upload {
  margin-top: 5px;
  display: block !important;
}
</style>